import { enumXMLType, kSmallIcon } from "../constants";
import { SVG_DrawImage } from "../utils/SVG_DrawImage";
import { XML_Scale } from "../utils/XML_Scale";
import { XML_DrawPlanIconPDF } from "../utils/XML_DrawPlanIconPDF";
import { XML_GetScale } from "../utils/XML_GetScale";
import { XML_ScaleAndShiftX } from "../utils/XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "../utils/XML_ScaleAndShiftY";
import { QBoxOverlay_AppIcon } from "./QBoxOverlay_AppIcon";

export class QBoxOverlay_Add extends QBoxOverlay_AppIcon {
  constructor() {
    super();
    this.overlayType = "add";
    this.fFillColor = "#00AA00";
    this.fBorderColor = "#33FF33";
  }

  DoAltRender(altCanvas) {
    var altCanvasType = altCanvas.GetCanvasType();
    var altCanvasElement = altCanvas.GetCanvasElement();

    var x = this.GetPositionX();
    var y = this.GetPositionY();

    var boxWidth = this.fChartBox.GetWidth();
    if (this.fOverrideWidth !== null) {
      boxWidth = this.fOverrideWidth;
    }
    var layer = this.GetLayer();
    var scale = XML_GetScale(altCanvasElement, layer); // drawElement["scale"];
    if (scale != null) boxWidth *= scale;
    switch (altCanvasType) {
      case "SVG":
        SVG_DrawImage(
          this.fHorzOffset + this.fDeltaDefX,
          this.fVertOffset + this.fDeltaDefY,
          24,
          24,
          null,
          null,
          null,
          this.fEnabledImage,
          layer,
          altCanvasElement
        );
        break;
      case "XML":
        var docType = altCanvasElement.GetDocType();
        var x0 = null;
        var y0 = null;
        //Just need altrenders for these.
        if (docType === enumXMLType.PDF) {
          var lineLen = Math.floor(boxWidth / 17);
          x0 = XML_ScaleAndShiftX(x, altCanvasElement, layer);
          y0 = XML_ScaleAndShiftY(y, altCanvasElement, layer);
          y0 = altCanvasElement.ConvertY(y0);
          var iconBase = this.fIconSize ?? kSmallIcon.imageWidth;
          var scaledIconSize = Math.round(XML_Scale(iconBase, altCanvasElement, layer));
          XML_DrawPlanIconPDF(
            x0,
            y0,
            scaledIconSize,
            scaledIconSize,
            lineLen,
            this.fFillColor,
            this.fBorderColor,
            this.getExportIconType(),
            layer,
            altCanvasElement
          );
        } else {
          var chartBox = this.fChartBox;
          if (!chartBox.GetDataObj()) {
            y += 2;
          }
          var coords = this.getPPTCoordinates(x, y, altCanvasElement, layer);
          x0 = coords.x0;
          y0 = coords.y0;
          y0 = altCanvasElement.ConvertY(y0);
          this.drawPPTIcon(x0, y0, altCanvasElement, layer);
        }
        break;
    }
  }
}
